export default __webpack_public_path__ + "static/media/UnpackingAndCycled.1ef058de.mp4";